import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from '@salesforce/design-system-react';
import { IconSettings, Input } from '@salesforce/design-system-react';
import moment from 'moment';

export const DatePickerField = ({ enabled, required, label, fieldName, handleChange, error, defaultValue }) => {
  const [startDate, setStartDate] = useState(required && new Date());

  useEffect(() => {
    if (defaultValue) {
      setStartDate(new Date(defaultValue));
    }
  }, [defaultValue]);

  return (
    <div className='date-field'>
      <IconSettings iconPath='/assets'>
        <DatePicker
          name={fieldName}
          input={<Input onChange={() => {}}/>}
          value={startDate}
          disabled={!enabled}
          labels={{ label }}
          required={required}
          errorText={error}
          defaultValue={defaultValue}
          onChange={ (event, data) => {
            setStartDate(data.date);
            handleChange(event, { fieldName, value: moment(data.date).format('YYYY-MM-DD') });
          }}
          formatter={(date) => {
            return date ? moment(date).format('MMM D, YYYY') : '';
          }}
          parser={(dateString) => {
            return moment(dateString, 'MMM D, YYYY').toDate();
          }}>
        </DatePicker>
      </IconSettings>
    </div>
  );
};

DatePickerField.propTypes = {
  enabled: PropTypes.bool,
  required: PropTypes.bool,
  label: PropTypes.string,
  fieldName: PropTypes.string,
  handleChange: PropTypes.func,
  error: PropTypes.string,
  defaultValue: PropTypes.string,
};
